export default __webpack_public_path__ + "static/media/a011-5.2eafb5cd.svg";